/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Submit_JobInputs */



/**
* | output |
* | --- |
* | "Submit {count} Job" |
*
* @param {Submit_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const submit_job = /** @type {((inputs: Submit_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Submit_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Soumettre ${i?.count} tâche`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count}-Job einreichen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Invia ${i?.count} Lavoro`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Отправить задание ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Enviar trabajo ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`提交 ${i?.count} 工作`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.count} ジョブを送信`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.count} जॉब सबमिट करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Submeter vaga ${i?.count}`)
	return /** @type {LocalizedString} */ (`Submit ${i?.count} Job`)
});